import { useFormContext } from 'react-hook-form'
import { i18n } from '@lingui/core'
import { FormFieldCell, FormControl, FormField, FieldErrorMessage } from '~/components'
import { Input } from '~/components/ui/input'

type SonstigesSpecifyInputProps = {
  // Full form path of the free-text field revealed by a "Sonstiges" checkbox.
  name: string
  // Defaults to "Bitte spezifizieren".
  label?: string
  required?: boolean
  // Grid placement etc. handed to the cell (e.g. "col-start-2" to center it).
  className?: string
}

// The free-text "please specify" input revealed when a checkbox group's
// "Sonstiges" option is ticked. Centralizes the touch-gated revalidation and
// error display that were previously copy-pasted between the private and
// business origin-of-funds branches (finanzielle-verhaeltnisse). The caller owns
// the reveal condition and the surrounding grid; this owns the input + its error.
export const SonstigesSpecifyInput = ({
  name,
  label,
  required,
  className,
}: SonstigesSpecifyInputProps) => {
  const form = useFormContext()
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field, fieldState }) => (
        <FormFieldCell
          className={className}
          required={required}
          requireTouched
          label={label ?? i18n._('Bitte spezifizieren')}
        >
          <FormControl>
            <Input
              {...field}
              value={typeof field.value === 'string' ? field.value : ''}
              onChange={(e) => {
                field.onChange(e)
                if (fieldState.isTouched && e.target.value.trim().length > 0) {
                  form.trigger(name)
                }
              }}
              onBlur={() => {
                field.onBlur()
                form.trigger(name)
              }}
            />
          </FormControl>
          <FieldErrorMessage fieldState={fieldState} requireTouched />
        </FormFieldCell>
      )}
    />
  )
}
